const submenuComponentConstants = {
    EMPTY_STRING_VALUE: '',
}

export default submenuComponentConstants;